import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

//form
import Login from './login';
import Utama from './utama';
// import ProtectedRoute from "./ProtectedRoute";

// const url_aplikasi = "http://localhost/khisan_api";
// const url_file = "http://localhost/khisan_file";
// const basename = "";

// const url_aplikasi = "https://dev-khisan.keisharesto.com/khisan_api";
// const url_file = "https://dev-khisan.keisharesto.com/khisan_file";
// const basename = "";

const url_aplikasi = "https://khisanresto.com/khisan_api";
const url_file = "https://khisanresto.com/khisan_file";
const basename = "";

function App() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route
          path="/login"
          element={
            <Login
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
        <Route
          path="*"
          element={
            <Utama
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;